export default __webpack_public_path__ + "static/media/fridge1-after1-1024w.7f35b42e.webp";